import { FC } from 'react';
import Create from 'components/elements/components/Create';

const Screen: FC = () => {
  return (
    <Create
      elementsEntityName="client-elements"
      segmentIdKey="client_segment_id"
    />
  );
};

export default Screen;
